import styled from '@emotion/styled';
import { Progress } from '@playdapp/ui';

const LoadingLayerContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
`;

const LoadingLayerOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
`;

const SpinnerLayer = () => (
    <LoadingLayerContainer>
      <LoadingLayerOverlay />
      <Progress size="large" />
    </LoadingLayerContainer>
  );

export default SpinnerLayer;
